import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from './shared';

const InstallmentCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [amount, setAmount] = useState('1.000,00');
  const [installments, setInstallments] = useState('12');
  const [interestRate, setInterestRate] = useState('2,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(parseBrazilianNumber(amount)) || 0;
    const n = parseInt(installments) || 0;
    const i = (parseFloat(parseBrazilianNumber(interestRate)) || 0) / 100;
    if (p <= 0 || n <= 0) return;

    let installment, total, interest;
    if (i === 0) {
      installment = p / n;
      total = p;
      interest = 0;
    } else {
      // Fórmula PRICE
      installment = p * (i * Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
      total = installment * n;
      interest = total - p;
    }

    const res = { installment, total, interest };
    setResultState(res);
    onResultChange([
      { label: 'Valor à Vista', value: `R$ ${p.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Parcela', value: `R$ ${res.installment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Total a Prazo', value: `R$ ${res.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Juros Totais', value: `R$ ${res.interest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Valor Total (R$)" value={amount} onChange={setAmount} required isNumeric type="text" />
          <FormField label="Número de Parcelas" value={installments} onChange={setInstallments} required isInteger type="text" step="1" />
          <FormField label="Juros (% a.m.)" value={interestRate} onChange={setInterestRate} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Parcelas
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Valor da Parcela" value={`R$ ${resultState.installment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
            <ResultCard title="Juros Totais" value={`R$ ${resultState.interest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Total Final" value={`R$ ${resultState.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="slate" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Dicas de Parcelamento"
        tips={[
          'O parcelamento "sem juros" geralmente já inclui o custo financeiro no preço à vista',
          'Sempre compare o preço total parcelado com o valor à vista com desconto',
          'Juros compostos fazem o valor total subir rapidamente em prazos longos',
          'Avalie se a parcela cabe no seu orçamento mensal sem comprometer o básico'
        ]}
      />
    </div>
  );
};

export default InstallmentCalculator;
